export const properties = window.config.properties;
